/* 
Common code for each of the views making up the role page.
*/
import * as action from "@/store/roles/action-types";

export default {
  data() {
    return {
      arrivedFromListing: false
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.arrivedFromListing = from.path.startsWith("/roles");
    });
  },
  computed: {
    roleId() {
      return parseInt(this.$route.params.id);
    },
    nextPageAction() {
      return action.LIST_NEXT_PAGE;
    },
    previousPageAction() {
      return action.LIST_PREVIOUS_PAGE;
    },
    breadcrumbs() {
      return this.$store.state.roles.view.breadcrumbs;
    },
    state() {
      return this.$store.state.roles.view;
    },
    loaded() {
      return this.state.loaded;
    },
    role() {
      return this.state.data;
    },
    title() {
      return this.role.name ? this.role.name : "...";
    }
  },
  watch: {
    roleId() {
      this.reload();
    },
    loaded() {
      this.reload();
    }
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      this.$store.dispatch(action.VIEW_REFRESH, this.roleId);
    }
  }
};
